import { useQuery } from "@tanstack/react-query";
import { canUseFinanceCleanup, CLEANUP_ORG_ID } from "@/api/finance-cleanup";
import { useAuth } from "@/hooks/useAuth";
import { useOrganization } from "@/hooks/useOrganization";

export function useFinanceCleanupAccess() {
  const { user, sessionGeneration, isLoading: authLoading } = useAuth();
  const { organizationId, isLoading: orgLoading } = useOrganization();
  const eligible = !authLoading && !orgLoading && !!user?.id && organizationId === CLEANUP_ORG_ID;
  const query = useQuery({
    queryKey: ["finance-cleanup-access", organizationId, user?.id, sessionGeneration],
    queryFn: () => canUseFinanceCleanup(organizationId!, user!.id),
    enabled: eligible,
    retry: false,
  });
  return {
    ...query,
    allowed: eligible && query.isSuccess && query.data === true,
    loading: authLoading || orgLoading || (eligible && query.isPending),
    organizationId,
    // Fresh principal/session = fresh preview and confirmation. No cross-context drafts.
    contextKey: `${organizationId}:${user?.id}:${sessionGeneration}`,
  };
}
